<template>
  <div class="app-subscription">
    <div class="app-subscription__content">
      <router-view />
    </div>
    <SliderInContainer />
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import SliderInContainer from './general/SliderInContainer.vue';

// @TODO Centralize in pinia store, see https://bureaux-a-partager.atlassian.net/browse/MATCH-9839
const isMobile = ref(false);

const checkIsMobile = () => {
  isMobile.value = window.BREAKPOINTS.isMobile;
};

onMounted(async () => {
  checkIsMobile();
  window.addEventListener('resize', checkIsMobile);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkIsMobile);
});
</script>
